import {
  BetaRegistrationTokenVaultActions,
  PublicTokenVaultActions,
  UserEmailTokenVaultActions,
  UserRegistrationConfirmationTokenVaultActions,
  UserTwoFATokenVaultActions,
} from '../token-vault';
import { OtherEmailActions } from './other-email-types.enum';

export type EmailActions =
  | OtherEmailActions
  | UserEmailTokenVaultActions
  | PublicTokenVaultActions
  | UserTwoFATokenVaultActions
  | UserRegistrationConfirmationTokenVaultActions.USER_REGISTRATION_EMAIL_CONFIRMATION
  | BetaRegistrationTokenVaultActions;

export const AllEmailActions = {
  ...OtherEmailActions,
  ...UserEmailTokenVaultActions,
  ...PublicTokenVaultActions,
  ...UserTwoFATokenVaultActions,
  ...BetaRegistrationTokenVaultActions,
  USER_EMAIL_CONFIRMATION: UserRegistrationConfirmationTokenVaultActions.USER_REGISTRATION_EMAIL_CONFIRMATION,
} as const;
